import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { fileIconSelect } from '../FileIconSelect';
import { decodeDisabled, parseBool } from '../../services/globalMethods';
import { BpSpinner } from '../BpSpinner';
import { deepCopy } from '../forms/formFunctions';
import { substitute } from '../../services/stringsubstitutions';

const FileIcon = (props) => {
    const { file,item } = props;

    console.log('isEditable', item?.isEditable);
    var cssClass = item?.isEditable != null &&  parseBool(item?.isEditable,false) == false ? "locked": "";
    if (item?.isPublic === true) {
        cssClass += ' public';
    } 
    return <span className={` hub-file-explorer-file-icon file-icon-${file} ${cssClass}`}>{fileIconSelect(file)}</span>;
};

const CollapsibleSection = ({ children, open }) => {
    return (
        <div className={`hub-file-explorer-collapsable ${open ? 'is-open' : ''}`} open={open}>
            <div className="hub-file-explorer__inner">{children}</div>
        </div>
    );
};

const ItemList = ({
    attributes,
    parentItem,
    currentItem,
    items,
    selectedId,
    setSelectedId,
    currentOpenState,
    setCurrentOpenState,
    HandleOnEvent,
    main,
    props,
    showPopup,
    updateDisabledItems,
}) => {
    const handleClick = (index) => {
        // props.dataStore.get("selectedItem")
        setSelectedId(index === selectedId ? null : index);
    };

    const handleRightClick = (event, item) => {
        event.preventDefault();
        event.stopPropagation(); // Prevents event from bubbling to the parent

        if (parseBool(item?.attributes?.showPopupMenu) === false || parseBool(attributes?.showPopupMenu) === false) {
            return;
        }

        if (item?.path == null) return;
        if(!item.path.startsWith('/'))
            item.path = '/' + item.path;

        if (item.title === 'appsettings.json' || item.title === 'site-config.json') {
            updateDisabledItems('rename', true);
            updateDisabledItems('delete', true);
        } else {
            updateDisabledItems('rename', false);
            updateDisabledItems('delete', false);
        }
        updateDisabledItems('copy', true);
        updateDisabledItems('paste', true);
        showPopup(item, event);
    };

    if (typeof items === 'string') {
        var copyStack = deepCopy(props.collectionStack);
        copyStack.reverse();
        items = substitute(items, props.controller, copyStack) ?? [];
    }

    var sortItems = true;
    if (parentItem?.attributes?.sortItems) {
        sortItems = parseBool(parentItem?.attributes?.sortItems, true);
    }

    const itemListElements = [];
    var sortedItems =
        sortItems === false
            ? items // Do not sort items
            : items.sort((a, b) => {
                  if (a.items && !b.items) return -1;
                  if (!a.items && b.items) return 1;
                  return a.title.localeCompare(b.title);
              });

    if (main && props.layoutItem.settings.prefixItems) {
        sortedItems = [...props.layoutItem.settings.prefixItems, ...sortedItems];
    }
    


    sortedItems.forEach((item, index) => {
        const { title, path, icon, parentItem, items: nestedItems } = item;

        if (title === '.ignore') return; // Ignore items with title '.ignore'

        if(item.isEditable != null && item.isEditable == false || currentItem?.locked == true){
            item.locked = true;
        }        

        if (item.visible != null) {
            var copyStack = deepCopy(props.collectionStack);
            copyStack.reverse();
            var result = decodeDisabled(
                item,
                item.visible,
                props.controller,
                props.controller.props.dataStore,
                props.formGenerator.getFormData(),
                [item, ...copyStack]
            );

            if (!result) return;
        }
        var onClick = null;
        if (item.onClick != null) {
            const myOnClick = item.onClick;
            onClick = (p1, p2) => {
                var formData = { ...props.formGenerator.getFormData() };

                var copyStack = deepCopy(props.collectionStack);
                copyStack.push(props.layoutItem.settings || {});
                copyStack.reverse();
                props.formGenerator.runActions(props.layoutItem, myOnClick, p2 ?? p1, formData, copyStack);
            };
        }

        const generateGUID = () => {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
                const r = (Math.random() * 16) | 0;
                const v = c === 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        };

        
        if (main) {
            attributes = deepCopy(item.attributes ?? {});
        } else {
            attributes = { ...attributes, ...item?.attributes };
        }

        // console.log('path', item.path);
        item.id = item.id ?? generateGUID();

        console.log('id', item.isEditable);
        itemListElements.push(
            <li key={`${item.id}`} onContextMenu={(e) => handleRightClick(e, item)}>
                {nestedItems ? (
                    <FileExplorerSection
                        key={`${item.path}-${index}`}
                        path={item.path ?? title}
                        title={title}
                        parentItem={item}
                        attributes={attributes}
                        currentItem={item}
                        items={nestedItems}
                        icon={icon}
                        props={props}
                        selectedId={selectedId}
                        setSelectedId={setSelectedId}
                        currentOpenState={currentOpenState}
                        setCurrentOpenState={setCurrentOpenState}
                        HandleOnEvent={onClick ?? HandleOnEvent}
                        showPopup={showPopup}
                        updateDisabledItems={updateDisabledItems}
                    />
                ) : item.header != null ? (
                    <div className="file-explorer-header">{item.header}</div>
                ) : (
                    <a
                        href={path}
                        title={title}
                        className={`locked ${item.path ?? title}-index` === selectedId ? 'active' : 'inactive'}
                        onClick={(e) => {
                            e.preventDefault();
                            handleClick(`${item.path ?? title}-index`);
                            e.target.setAttribute('data-item', item);
                            onClick ? onClick() : HandleOnEvent(props.layoutItem.events.onClick, item);
                        }}>
                        <FileIcon file={icon} item={item}/> {title}
                    </a>
                )}
            </li>
        );
    });

    return <ul className="hub-file-explorer__itemlist">{itemListElements}</ul>;
};
const FileExplorerSection = ({
    path,
    title,
    attributes,
    parentItem,
    currentItem,
    items,
    icon,
    selectedId,
    setSelectedId,
    currentOpenState,
    setCurrentOpenState,
    HandleOnEvent,
    props,
    showPopup,
    updateDisabledItems,
}) => {

    const handleItemOnClick = () => {
        var newCurrentOpenState = { ...currentOpenState, [path]: !currentOpenState[path] ?? false };
        setCurrentOpenState(newCurrentOpenState);
    };

    var currentShow = currentOpenState[path] ?? false;
    return (
        <div className="hub-file-explorer__section">
            <button onClick={handleItemOnClick} className={`${currentShow ? 'isActive' : ''}`}>
                <span className="folder-caret">&gt;</span>
                <FileIcon file={icon} item={currentItem}/> {title}
            </button>
            <CollapsibleSection open={currentShow}>
                <ItemList
                   currentItem={currentItem}
                    items={items}
                    attributes={attributes}
                    parentItem={parentItem}
                    props={props}
                    selectedId={selectedId}
                    setSelectedId={setSelectedId}
                    currentOpenState={currentOpenState}
                    setCurrentOpenState={setCurrentOpenState}
                    HandleOnEvent={HandleOnEvent}
                    showPopup={showPopup}
                    updateDisabledItems={updateDisabledItems}
                />
            </CollapsibleSection>
        </div>
    );
};

const HubFileExplorerItemList = (props) => {
    var { controller, layoutItem, collectionStack, formGenerator } = props;
    const [currentContents, setCurrentContents] = useState(null);
    const [currentOpenState, setCurrentOpenState] = useState({});
    const [selectedId, setSelectedId] = useState(null);
    const [popup, setPopup] = useState({ visible: false, x: 0, y: 0, item: null });
    const [disabledItems, setDisabledItems] = useState(['popupMenuItems']);

    const popupRef = useRef(null);
    const fileInputRef = useRef(null);
    const fileZipRef = useRef(null);

    const HandleOnEvent = (onEvent, item) => {
        var formData = { ...formGenerator.getFormData() };

        var copyStack = deepCopy(collectionStack);
        copyStack.push(layoutItem.settings || {});
        copyStack.reverse();
        formGenerator.runActions(layoutItem, onEvent, item, formData, copyStack);
    };

    const showPopup = (item, event) => {
        if (parseBool(item?.attributes?.showPopupMenu) === false) {
            closePopup();
            return;
        }
        
        const parent = event.currentTarget.closest(".hub-file-explorer");// document.querySelector(".hub-file-explorer");
        const parentRect = parent.getBoundingClientRect();
        var top = event.clientY - parentRect.top
        var left = event.clientX - parentRect.left

        var singleItem = deepCopy(item)
        delete singleItem.items ;
        if(singleItem.icon == 'folder'){
            singleItem.folder = singleItem.path;
        }
        else if (singleItem.path.indexOf('/') > -1){
            singleItem.folder =  singleItem.path.substring(0, singleItem.path.lastIndexOf('/'));
        }

        const popupActon = {
            type: 'setProperties',
            settings:{
                popupMenu: {
                    top:  top,
                    left:  left,
                    item: singleItem
                }
            }
        }
        formGenerator.runActions(layoutItem, popupActon,{},{});

         setPopup({ visible: true, x: left, y: top, item });
    };

    const updateDisabledItems = (action, disable) => {
        setDisabledItems((prevDisabledItems) => {
            if (disable) {
                return [...prevDisabledItems, action];
            } else {
                return prevDisabledItems.filter((item) => item !== action);
            }
        });
    };

    const closePopup = () => {
        const popupActon = {
            type: 'setProperties',
            settings:{
                popupMenu: null
            }
        }
        
        formGenerator.runActions(layoutItem, popupActon,{},{});        
        setPopup({ ...popup, visible: false });
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                var data =
                    typeof layoutItem.key === 'string' ? await controller.props.dataStore.get(layoutItem.key) : layoutItem.key;

                    if(currentContents != data){
                        setCurrentOpenState({});
                    }
                if (data) {
                    setCurrentContents(data);
                }
                
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [controller.props.dataStore, layoutItem.originalReplacements.DATASTORE]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closePopup();
                return;
            }
        };

        const handleClickOutside = (event) => {
             var element = event.target?.closest(".popup-menu");
             if(element == null){
                 closePopup();
             }
        };

        if (popup.visible) {
            document.addEventListener('keydown', handleKeyDown);
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [popup.visible]);


    var emptyArray = [];
    if(currentContents == null || currentContents.items == null)
        return <></>
    return (
        
        // <div className={`hub-file-explorer tooltip-container ${layoutItem.class || ''}`}>
   
        //         <div className="hub-file-explorer__section">
        //             <input
        //                 type="file"
        //                 ref={fileInputRef}
    //                 onChange={handleFileUpload}
        //                 style={{ display: 'none' }} // Hide the file input
        //                 multiple // Allows multiple file selection
        //             />
        //             <input
        //                 type="file"
        //                 ref={fileZipRef}
        //                 onChange={handleZipUpload}
        //                 accept='.zip'
        //                 style={{ display: 'none' }} // Hide the file input
        //             />                    
                    <ItemList
                        key="File-Explorer-List"
                        items={currentContents?.items}
                        props={props}
                        selectedId={selectedId}
                        setSelectedId={setSelectedId}
                        currentOpenState={currentOpenState}
                        setCurrentOpenState={setCurrentOpenState}
                        HandleOnEvent={HandleOnEvent}
                        attributes={layoutItem.attributes}
                        main={true}
                        showPopup={showPopup}
                        updateDisabledItems={updateDisabledItems}
                    />
    );
};

export default HubFileExplorerItemList;
